var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderImport = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.0312 2.21873C10.7375 1.92498 10.2625 1.92498 9.97188 2.21873L5.96875 6.21873C5.675 6.51248 5.675 6.98748 5.96875 7.2781C6.2625 7.56873 6.7375 7.57185 7.02813 7.2781L9.74687 4.55935L9.75 12.25C9.75 12.6656 10.0844 13 10.5 13C10.9156 13 11.25 12.6656 11.25 12.25V4.55935L13.9688 7.2781C14.2625 7.57185 14.7375 7.57185 15.0281 7.2781C15.3187 6.98435 15.3219 6.50935 15.0281 6.21873L11.0312 2.21873ZM5 12.75C5 12.3344 4.66562 12 4.25 12C3.83437 12 3.5 12.3344 3.5 12.75V15.25C3.5 16.7687 4.73125 18 6.25 18H14.75C16.2688 18 17.5 16.7687 17.5 15.25V12.75C17.5 12.3344 17.1656 12 16.75 12C16.3344 12 16 12.3344 16 12.75V15.25C16 15.9406 15.4406 16.5 14.75 16.5H6.25C5.55938 16.5 5 15.9406 5 15.25V12.75Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderImport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d92ac5001a6ac17a1116fc1c72493991.svg";